import { render, staticRenderFns } from "./field-multi.vue?vue&type=template&id=1fa7221b&scoped=true&"
import script from "./field-multi.vue?vue&type=script&lang=js&"
export * from "./field-multi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa7221b",
  null
  
)

export default component.exports